<template>
  <v-form>
    <v-row class="d-flex space-between">
      <template v-if="!cadastroConcluidoComPendencia">
        <v-col cols="12" sm="12" md="4">
          <v-text-field
            outlined
            cols="12"
            sm="12"
            md="4"
            hint="Dados do recibo"
            v-model="dadosDaNota.notaRecibo"
          >
            <template class="m-p-4" v-slot:label>
              <strong>NOTA/RECIBO</strong>
              <v-icon style="vertical-align: middle">description</v-icon>
            </template>
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="4">
          <v-menu
            ref="menuRecibo"
            v-model="menuRecibo"
            :close-on-content-click="false"
            transition="scale-transition"
            origin="center center"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                :value="formatarDataExibicao(dadosDaNota.dataRecibo)"
                label="DATA NOTA/RECIBO"
                hint="Data do documento"
                persistent-hint
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="dadosDaNota.dataRecibo"
              :active-picker.sync="activePicker2"
              min="1950-01-01"
              @change="dateSaveRecibo"
            />
          </v-menu>
        </v-col>

        <v-col cols="12" sm="12" md="4">
          <v-btn block x-large color="#363494" @click="criarNota" v-on:dblclick.prevent>
            <v-icon color="#fff" left>mdi-clipboard-check-outline</v-icon>
            <span style="color:White;">GERAR NOTA/RECIBO</span>
          </v-btn>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <gerenciadorAnexos
            ref="anexosNota"
            tipo-entidade="nota"
            modo="fila_local"
            :entidade-id="registroCriadoId"
            mensagem-opcional="Os anexos sao opcionais e serao enviados apos salvar a nota."
          />
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <VueEditor placeholder="Observacoes do documento" v-model="dadosDaNota.observacoes" />
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <listaProdutosNotaStart :itemFiltrado="itemFiltrado" :itemEmpenho="itemEmpenho" />
        </v-col>
      </template>

      <v-col cols="12" sm="12" md="12">
        <v-alert
          v-if="cadastroConcluidoComPendencia"
          type="warning"
          outlined
          class="mb-4"
        >
          Nota salva. Revise os anexos pendentes abaixo ou feche esta tela.
        </v-alert>

        <div v-if="cadastroConcluidoComPendencia" class="d-flex justify-end mb-4">
          <v-btn text color="#75756d" @click="fecharAposPendencia">Fechar</v-btn>
        </div>

        <gerenciadorAnexos
          v-if="cadastroConcluidoComPendencia"
          ref="anexosNota"
          tipo-entidade="nota"
          modo="fila_local"
          :entidade-id="registroCriadoId"
          mensagem-opcional="Os anexos sao opcionais e serao enviados apos salvar a nota."
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import axios from "axios";
import barramento from "@/barramento";
import { urlApi, showError } from "@/global";
import {
  formatarDataParaExibicao as formatarDataExibicaoBr,
  normalizarDataEntrada as normalizarDataIso,
} from "@/utils/date";
import { VueEditor } from "vue2-editor";
import gerenciadorAnexos from "../anexos/gerenciadorAnexos";
import listaProdutosNotaStart from "./listaProdutosNotaStart";

const criarDadosIniciaisNota = () => ({
  idEmpenho: null,
  notaRecibo: "",
  dataRecibo: "",
  valorNf: 0,
  observacoes: "",
  itens_nota: [],
});

export default {
  name: "gerarNota",
  props: {
    itemEmpenho: {},
    listaNotas: [],
    itemFiltrado: [],
    isNota: [Boolean, Function],
    primeiroEmpenho: [Boolean, Function],
    somaValorTotalNotasEmitidas: [Number, String],
  },
  components: { VueEditor, gerenciadorAnexos, listaProdutosNotaStart },

  data: () => ({
    dadosDaNota: criarDadosIniciaisNota(),
    listaProdutosNf: [],
    bdNotas: [],
    valorNota: 0,
    activePicker: null,
    activePicker2: null,
    menu: false,
    menuRecibo: false,
    cadastroConcluidoComPendencia: false,
    registroCriadoId: null,
  }),
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "Ano"));
    },
    menuRecibo(val) {
      val && setTimeout(() => (this.activePicker2 = "Ano"));
    },
  },
  methods: {
    limparForm() {
      this.dadosDaNota = criarDadosIniciaisNota();
      this.cadastroConcluidoComPendencia = false;
      this.registroCriadoId = null;
      document
        .querySelectorAll(".c-table-nota .u-clear-data input")
        .forEach((quantidade) => (quantidade.value = 0));
      if (this.$refs.anexosNota) {
        this.$refs.anexosNota.resetState();
      }
    },

    dateSave(date) {
      this.$refs.menu.save(date);
    },
    dateSaveRecibo(date) {
      const dataNormalizada = this.normalizarData(date);
      this.$refs.menuRecibo.save(dataNormalizada);
      this.dadosDaNota.dataRecibo = dataNormalizada;
    },
    formatarDataExibicao(valor) {
      return formatarDataExibicaoBr(valor);
    },
    normalizarData(valor) {
      return normalizarDataIso(valor);
    },
    fecharAposPendencia() {
      this.limparForm();
      document.getElementById("js-modal-nota__close").click();
    },
    async criarNota() {
      const itensParaNota = this.listaProdutosNf.filter(
        (it) => (it.emitidaNaNota || it.emitidaNaNotaAtual || 0) > 0
      );

      if (!itensParaNota.length) {
        showError("Selecione ao menos um produto e informe a quantidade emitida para o documento.");
        return;
      }

      this.dadosDaNota.idEmpenho = this.itemEmpenho.id;
      this.dadosDaNota.valorNf = this.valorNota;
      this.dadosDaNota.dataRecibo = this.normalizarData(this.dadosDaNota.dataRecibo);

      this.dadosDaNota.itens_nota = itensParaNota.map((it) => ({
        item_empenho_id: it.item_empenho_id || it.id,
        quantidade_nota: it.emitidaNaNota || it.emitidaNaNotaAtual || 0,
      }));

      try {
        const res = await axios.post(`${urlApi}/nota`, this.dadosDaNota);
        const notaId = res && res.data ? res.data.id : null;
        const anexoRef = this.$refs.anexosNota;

        barramento.EnviarNotas(true, this.itemEmpenho.id);
        barramento.EnviarLoadPregao(true);

        if (anexoRef && anexoRef.hasPendingFiles()) {
          if (!notaId) {
            this.registroCriadoId = null;
            this.cadastroConcluidoComPendencia = true;
            this.$toasted.global.defaultError({
              msg: "Documento salvo, mas o ID nao foi retornado para enviar os anexos.",
            });
            return;
          }

          this.registroCriadoId = notaId;
          const uploadResult = await anexoRef.uploadPendingFiles({
            entidadeId: notaId,
            silentSuccess: true,
          });

          barramento.EnviarNotas(true, this.itemEmpenho.id);
          barramento.EnviarLoadPregao(true);

          if (uploadResult.failed.length > 0) {
            this.cadastroConcluidoComPendencia = true;
            this.$toasted.global.defaultError({
              msg: "Documento salvo, mas alguns anexos falharam. Revise a secao de documentos.",
            });
            return;
          }
        }

        this.limparForm();
        document.getElementById("js-modal-nota__close").click();
        this.$toasted.global.defaultSuccess();
      } catch (err) {
        showError(err);
      }
    },
  },

  created() {
    barramento.getProdutosNota((listraProdutosNf) => {
      this.listaProdutosNf = listraProdutosNf;
    });
    barramento.getTotalNota((totalNota) => {
      this.valorNota = totalNota;
    });
  },
};
</script>

<style>
.form-pregao__item {
  font-family: "Georama", sans-serif !important;
}
</style>
